import axios from 'axios'

export default {
  async sendEmail(emailData) {
    let formData = {
      subject: emailData.subject,
      body: emailData.body,
      recipients: emailData.recipients,
    }
    let res = await axios.post('https://europe-west1-freelance-ffddb.cloudfunctions.net/email-sender', formData)
    console.log(`Response Status: ${res.status}, Data: ${res.data}`)
  },
}
